import { render } from "./PlayoutLimitWarning.vue?vue&type=template&id=0936f240"
import script from "./PlayoutLimitWarning.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutLimitWarning.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TVPlayoutV2/PlayoutLimitWarning.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0936f240"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0936f240', __exports__)) {
    api.reload('0936f240', __exports__)
  }
  
  module.hot.accept("./PlayoutLimitWarning.vue?vue&type=template&id=0936f240", () => {
    api.rerender('0936f240', render)
  })

}


export default __exports__